"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnKeyPress = void 0;

var react_1 = require("react");

var defaultOptions = {
  isActive: true
};
/**
 * useOnKeyPress detects key down events for a given key.
 * @param targetKey Key to listen for.
 * @param handler Function to call when user presses the given key.
 * @param options
 */

var useOnKeyPress = function useOnKeyPress(targetKey, handler, options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  var _a = options.isActive,
      isActive = _a === void 0 ? true : _a;
  var downHandler = (0, react_1.useCallback)(function (event) {
    if (isActive && event.key === targetKey) {
      handler === null || handler === void 0 ? void 0 : handler(event);
    }
  }, [targetKey, handler, isActive]);
  var ref = (0, react_1.useRef)(window);
  var refCallback = (0, react_1.useCallback)(function (node) {
    if (ref.current) {
      ref.current.removeEventListener('keydown', downHandler);
    }

    if (node) {
      node.addEventListener('keydown', downHandler);
    }

    ref.current = node;
  }, [downHandler]);
  (0, react_1.useEffect)(function () {
    if (ref.current !== window) {
      return;
    }

    window.addEventListener('keydown', downHandler);
    return function () {
      window.removeEventListener('keydown', downHandler);
    };
  }, [downHandler]);
  return [refCallback];
};

exports.useOnKeyPress = useOnKeyPress;